import React from 'react'
import './Portfolio.css'
import{Swiper, SwiperSlide} from 'swiper/react'
import inkniche from "../../img/inkniche.png"
import john from "../../img/john.jpeg"
import milina from "../../img/milina.jpeg"
import rings from "../../img/rings.jpeg"
import titan from "../../img/titan.png"
import whisky from "../../img/whisky.png"
import crypto from "../../img/crypto.png"
import musicapp from "../../img/musicapp.png"
import 'swiper/css'
import { useContext } from "react";
import { themeContext } from '../../Context';
const Portfolio = () => {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
  return (
    <div className="portfolio" id='Portfolio'>
        {/*Heading */}
        <span style = {{color : darkMode? 'white': ''}}>Recent Projects</span>
        <span>Portfolio</span>

        {/*Slider */}
        <Swiper
        spaceBetween={50}
        breakpoints={{
            576: {
              // width: 576,
              slidesPerView: 3,
            },
            480: {
              // width: 768,
              slidesPerView: 1,
            },
          }}

        grabCursor={true}
        className='portfolio-slider'
        >
            <SwiperSlide>
                <img src={titan} alt='' />
            </SwiperSlide>

            <SwiperSlide>
                <img src={rings} alt='' />
            </SwiperSlide>

            <SwiperSlide>
                <img src={john} alt='' />
            </SwiperSlide>

            <SwiperSlide>
                <img src={milina} alt='' />
            </SwiperSlide>
            
            <SwiperSlide>
                <img src={inkniche} alt='' />
            </SwiperSlide>

            <SwiperSlide>
                <img src={whisky} alt='' />
            </SwiperSlide>

            <SwiperSlide>
                <img src={crypto} alt='' />
            </SwiperSlide>
        </Swiper>
    </div>
  )
}

export default Portfolio